import html2canvas from "html2canvas";


export const exportNode2PngDataURL = async (node: HTMLElement, quality: number = 0.8,scale=2): Promise<string> => {
    // create a canvas
    const canvas = await html2canvas(node, {
        allowTaint: false,
        backgroundColor: null,
        useCORS: true,
        logging: false,
        ignoreElements:(element)=>{
            return !!element.getAttribute('ignoreImageExport');
        },
        width: node.offsetWidth,
        height: node.offsetHeight,
        scale: scale,
    })

    // uncomment to show the image export from canvas
    const imageUrl = canvas.toDataURL('image/png',quality);

    return imageUrl;
}
export const exportNode2JpgDataURL = async (node: HTMLElement, quality: number = 0.8,scale=2,backgroundColor:string='black'): Promise<string> => {
  // create a canvas
  const canvas = await html2canvas(node, {
    allowTaint: false,
    backgroundColor: backgroundColor,
    useCORS: true,
    logging: false,
    ignoreElements:(element)=>{
      return !!element.getAttribute('ignoreImageExport');
    },
    width: node.offsetWidth,
    height: node.offsetHeight,
    scale: scale,
  })

  // uncomment to show the image export from canvas
  const imageUrl = canvas.toDataURL('image/jpeg',quality);

  return imageUrl;
}

export const preloadImage=(url)=> {
  const img = new Image();
  img.onerror = () => {
    console.warn('Failed to preload image:', url);
  };
  img.src = url;
}


export const IA_STYLE=[
  { label: 'DSLR Photography', value: ':: professional DSLR photograph, sharp focus, high resolution' },
  { label: 'Portrait Photography', value: ':: portrait photograph, studio lighting, shallow depth of field' },
  { label: 'Cinematic', value: ':: cinematic scene, film still, anamorphic lens, dramatic lighting' },
  { label: 'Hyper realistic', value: ':: hyperrealistic, extremely detailed photograph' },
  { label: 'Black and White', value: ':: black and white photograph, high contrast' },
  { label: 'Sepia Tone', value: ':: sepia tone vintage photograph' },
  { label: 'Watercolor Painting', value: ':: watercolor painting on textured paper, soft colors' },
  { label: 'Oil Painting', value: ':: classic oil painting on canvas' },
  { label: 'Flat Design', value: ':: flat design, minimal vector illustration' },
  { label: 'Minimalist', value: ':: minimalist, clean composition, negative space' },
  { label: 'Line Art', value: ':: clean line art illustration, monochrome' },
  { label: 'Sketch Drawing', value: ':: pencil sketch drawing, rough strokes' },
  { label: 'Colored Pencil Drawing', value: ':: colored pencil drawing, textured paper' },
  { label: 'Ink Illustration', value: ':: ink illustration, cross-hatching' },
  { label: 'Vaporwave Aesthetic', value: ':: vaporwave, retro 80s pastel neon colors' },
  { label: 'Synthwave', value: ':: synthwave, neon grid, retro-futuristic colors' },
  { label: 'Futuristic Sci-Fi', value: ':: futuristic science fiction concept art' },
  { label: 'Cyberpunk', value: ':: cyberpunk cityscape, neon lights, rain' },
  { label: 'Neon Lighting', value: ':: neon lighting, glowing accents' },
  { label: '3D Render', value: ':: 3D render, realistic lighting and materials' },
  { label: 'Isometric 3D', value: ':: isometric 3D render, game asset style' },
  { label: '8-bit Pixel Art', value: ':: 8-bit retro pixel art' },
  { label: '16-bit Pixel Art', value: ':: 16-bit SNES-era pixel art' },
  { label: 'Pixar Animation Studio', value: ':: Pixar animated movie style, soft lighting, expressive characters' },
  { label: 'Studio Ghibli Animation', value: ':: Studio Ghibli hand-drawn anime art, whimsical atmosphere' },
  { label: 'Anime Illustration', value: ':: anime illustration, cel shading, vibrant colors' },
  { label: 'Manga Black & White', value: ':: manga-style black and white ink art' },
  { label: 'Moebius Comic Art', value: ':: Moebius comic book art, surreal colors, fine lines' },
  { label: 'Disney Animation', value: ':: Walt Disney animated movie art' },
  { label: 'Dreamlike Surrealism', value: ':: dreamlike surrealist painting' },
  { label: 'Van Gogh Painting', value: ':: oil painting in the style of Vincent van Gogh' },
  { label: 'Claude Monet Impressionism', value: ':: impressionist painting in the style of Claude Monet' },
  { label: 'Pencil Blueprint', value: ':: architectural pencil blueprint drawing' },
  { label: 'Steampunk', value: ':: steampunk aesthetic, gears, brass, Victorian era' },
  { label: 'Noir Film', value: ':: 1940s noir film style, dramatic shadows' },
  { label: 'Pop Art', value: ':: pop art, bold colors, comic book dots' },
  { label: 'Low Poly 3D', value: ':: low poly 3D model style, flat shading' },
  { label: 'Fantasy Concept Art', value: ':: fantasy world concept art, epic lighting' },
  { label: 'Dark Fantasy', value: ':: dark fantasy illustration, gothic mood' },
  { label: 'Post-Apocalyptic', value: ':: post-apocalyptic concept art, muted tones' },
  { label: 'Art Deco', value: ':: art deco style, geometric patterns, gold accents' },
  { label: 'Ukiyo-e', value: ':: Japanese ukiyo-e woodblock print' }
];
